import {
  isReclamationRequestGraphQLError,
  RECLAMATION_REQUEST_ERROR_CODE,
} from 'common/utils/reclamation/error';

export const getReclamationRequestErrorMessage = (error: unknown) => {
  if (isReclamationRequestGraphQLError(error)) {
    const errorCode = error.extensions.code;

    switch (errorCode) {
      case RECLAMATION_REQUEST_ERROR_CODE.STATE_CHANGE_NOT_ALLOWED:
        return 'h24_cancellation_error_marketplace_status_changed';
      case RECLAMATION_REQUEST_ERROR_CODE.RECLAMATION_ALREADY_SUBMITTED:
        return 'h24_claim_already_submitted_marketplace';
    }
  }

  return 'h24_something_went_wrong';
};
